import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './group.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const groupDirections = ['row', 'row-reverse', 'column', 'column-reverse'] as const
export type groupDirectionsType = typeof groupDirections

export const groupJustifyOptions = ['space-between', 'space-evenly', 'start', 'center', 'end'] as const
export type groupJustifyOptionsType = typeof groupJustifyOptions

export const groupAlignments = ['normal', 'center'] as const
export type groupAlignmentsType = typeof groupAlignments

export const groupGaps = ['none', '00', '01', '02', '03', '04', '05', '06', '07', '08'] as const
export type groupGapsType = typeof groupGaps

@customElement('cse-group')
export class CSEGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Boolean })
  inline = false

  @property({ type: Boolean })
  nowrap = false

  @property({ type: String })
  direction: groupDirectionsType[number] = 'row'

  @property({ type: String })
  justify: groupJustifyOptionsType[number] = 'start'

  @property({ type: String })
  alignment: groupAlignmentsType[number] = 'normal'

  @property({ type: String, attribute: 'column-gap' })
  columnGap: groupGapsType[number] = '04'

  @property({ type: String, attribute: 'row-gap' })
  rowGap: groupGapsType[number] = '04'

  override render() {
    const columnGapValue: keyof typeof csSpacing = `spacing${this.columnGap}`
    const rowGapValue: keyof typeof csSpacing = `spacing${this.rowGap}`
    
    return html`
      <div
        class="${classMap({
          'cse-group': true,
          'inline': this.inline,
          'no-wrap': this.nowrap,
        })}"
        style="
          flex-direction: var(--cse-group-direction, ${this.direction});
          justify-content: var(--cse-group-justify, ${this.justify});
          align-items: var(--cse-group-alignment, ${this.alignment});
          column-gap: var(--cse-group-column-gap, ${csSpacing[columnGapValue]});
          row-gap: var(--cse-group-row-gap, ${csSpacing[rowGapValue]});
        "
      >
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-group': CSEGroup
  }
}
